import { useState } from 'react';
import { ProReducerInitialStateType } from './ProReducerContext';

export const useProState = (initState: ProReducerInitialStateType) => {
  const [state] = useState(initState);

  return state;
};
